<pre [ngClass]="{'line-numbers': lineNumbers}" [attr.data-start]="start" [hidden]="!prismLoaded"><code #code [ngClass]="languageClass" class="mode-prism">{{query}}</code></pre>
